import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import { createMuiTheme, Paper, ThemeProvider } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import FastfoodIcon from "@material-ui/icons/Fastfood";
import SelectArticles from "../Forms/SelectArticles";
import { updateArrangement } from "../../store/ArrangementApi";
import articlesStore from "../../store/articles/ArticlesStore";
import { getArticles } from "../../store/articles/ArticlesApi";
import cloudStore from "../../store/CloudStore";
import CircularProgress from "@material-ui/core/CircularProgress";
import ActionButtonArrangement from "./ActionButtonArrangement";
import { useDialog } from "../Dialogs/DialogProvider";
import ArrangementSettingsDialog from "./ArrangementSettingsDialog";

const theme = createMuiTheme({
  palette: {
    error: {
      main: "#3f51b5",
    },
  },
});

const useStyles = makeStyles({
  createPosPaperContainer: { padding: 10, width: "calc(100% - 40px)", margin: 20 },
  textFieldContainer: {
    display: "flex",
    margin: 10,
  },
  label: { width: "40%" },
  input: { width: "60%" },
  labelError: { color: theme.palette.error.main },
});

function ArrangementsList(props) {
  const classes = useStyles();
  const [openDialog] = useDialog();
  const [expandedArrangements, setExpandedArrangements] = React.useState([]);
  const [articles, setArticles] = React.useState(articlesStore.articles);

  useEffect(() => {
    if (articles == null) {
      getArticles(cloudStore.merchant.id);
    }
  }, []);

  function onChangeArticles() {
    setArticles(articlesStore.articles);
  }

  useEffect(() => {
    articlesStore.on(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    return () => {
      articlesStore.removeListener(articlesStore.events.ARTICLES_UPDATED, onChangeArticles);
    };
  }, []);

  const handleOpenArrangementSettingsDialog = (arrangement) => {
    openDialog({
      children: (
        <ArrangementSettingsDialog
          fullWidth={true}
          spMerchantId={props.spMerchantId}
          spMerchant={props.spMerchant}
          arrangement={arrangement}
          article={articles[arrangement.m_article_id]}
        />
      ),
      fullWidth: true,
      maxWidth: "sm",
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Paper classes={{ root: classes.createPosPaperContainer }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <FastfoodIcon fontSize={"large"} />
            <Typography variant={"h6"} style={{ marginLeft: "8px" }}>
              {props.intl.formatMessage({ id: "arrangements" })}
            </Typography>
            <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
          </div>
          <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
          <SelectArticles
            filteredOutArticles={props.arrangements?.map((arrangement) => arrangement.m_article_id)}
            handleOnSelect={(article) => {
              let newData = { m_article_id: article.id };
              updateArrangement(props.spMerchantId, null, newData);
            }}
            label={props.intl.formatMessage({ id: "create_arrangement" })}
            helperText={props.intl.formatMessage({ id: "select_article" })}
          />
          <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
          {articles == null ? (
            <div align="center">
              <CircularProgress size={18} color="primary" />
            </div>
          ) : (
            <div className={classes.root}>
              {props.arrangements
                ?.filter((arrangement) => articlesStore.articles[arrangement.m_article_id])
                .map((arrangement) => (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: "80%", marginLeft: 20 }}>
                      <Typography display={"inline"}>
                        {articlesStore.articles[arrangement.m_article_id]?.name}
                      </Typography>
                    </div>
                    <div style={{ width: "20%" }}>
                      <ActionButtonArrangement
                        handleOpenArrangementSettingsDialog={() => handleOpenArrangementSettingsDialog(arrangement)}
                        arrangement={arrangement}
                        spMerchantId={props.spMerchantId}
                      />
                    </div>
                  </div>
                ))}
            </div>
          )}
        </Paper>
      </div>
    </ThemeProvider>
  );
}

export default withIntl(ArrangementsList);
